import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Main from './components/layout/Main';
import Home from './components/Home/Home';
import ErrorPage from './components/ErrorPage/ErrorPage';
import Hero from './components/Hero/Hero';
import Statics from './components/Statics/Statics';
import Blog from './components/Blog/Blog';
import Quiz from './components/Quiz/Quiz';
import QuizTopic from './components/QuizTopic/QuizTopic';
import About from './components/About/About';

function App() {

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Main></Main>,
      errorElement: <ErrorPage />,
      children: [
        {
          path: '/',
          loader: () => fetch('https://openapi.programming-hero.com/api/quiz'),
          element: <Home></Home>,
        },

        {
          path: '/home',
          loader: () => fetch('https://openapi.programming-hero.com/api/quiz'),
          element: <Home></Home>,
        },

        {
          path: '/hero',
          element: <Hero></Hero>,
        },

        {
          path: '/quiz',
          element: <Quiz></Quiz>,
        },
        {
          path: '/about',
          element: <About></About>,
        },

        {
          path: '/statics',
          loader: () => fetch('https://openapi.programming-hero.com/api/quiz'),
          element: <Statics></Statics>,
        },

        {
          path: '/blog',
          element: <Blog></Blog>,
        },

        {
          path: 'quiztopic/:id',
          loader: async ({ params }) => {
            return fetch(`https://openapi.programming-hero.com/api/quiz/${params.id}`);
          },
          element: <QuizTopic></QuizTopic>,
        },

        {
          path: '*',
          element: <ErrorPage></ErrorPage>,
        }

      ]
    }
  ])
  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
